import React, { useMemo } from 'react';
import type { ColorMaps } from '../../../core/models/user';

interface PaletteItemProps {
  palette: ColorMaps;
  width?: React.CSSProperties['width'];
  noGrayScale?: boolean;
  paletteStyle?: React.CSSProperties;
}

const greyColor = '#808080';

const PaletteItem: React.FC<PaletteItemProps> = ({ palette, noGrayScale, width, paletteStyle }) => {
  const colorPalette = useMemo(() => {
    if (noGrayScale) {
      return palette.colors.filter((color) => color.start !== -1 && color.end !== 0);
    } else {
      return palette.colors;
    }
  }, [noGrayScale, palette]);

  return (
    <div className="palette__bar">
      {colorPalette.map((palette) => {
        const portionWidth =
          palette.color === greyColor
            ? `2.50rem `
            : `${(Math.abs(palette.end - palette.start) * width) / 2}px`;
        return (
          <div
            className="palette__bar--portion disabled"
            key={palette.color}
            style={{
              width: portionWidth,
              backgroundColor: palette.color,
              ...paletteStyle,
            }}
            data-testid={`palette-color-${palette.color}`}
          ></div>
        );
      })}
    </div>
  );
};

export default PaletteItem;
